import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertsPage";
import Classes from "model";

export default function CaptureConfirmation(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    let data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "addEditAlertWidget", "alert", "type" ], "balanceAlert")
    .update([ "addEditAlertWidget", "alert", "alertMeWhen" ], "available balance")
    .update([ "addEditAlertWidget", "alert", "alertMeWhenBalanceIs" ], "less than")
    .update([ "addEditAlertWidget", "alert", "balanceThresholdAmount" ], "10.00")
    .submit();

    const addedAlert = data.addEditAlertWidget.alert;
    // Use static id of 100 since "nextID" could return different values depending on branding.
    addedAlert.id = "100";

    data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "currentAlertsWidget", "alerts" ], [ addedAlert, ...getDefaultPageData().currentAlertsWidget.alerts ])
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "addEditAlertWidget", "alertCreatedSuccessfullyBanner", "isActive" ], true)
    .submit();

    return <AlertsPage data={ data } ui={ ui } className="for-capture"/>;
}